<template>
    <div>
        <h1 style="font-size: 24px; color: black;">官方话题</h1>
        <el-card   shadow="never">
            <el-row  type="flex"  align="middle" >
                <el-col :span="6">
                        <span > 日期：</span>
                        <el-date-picker
                            v-model="queryData.timeDate"
                            type="daterange"
                            :clearable="false"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            value-format="yyyy-MM-dd">
                        </el-date-picker>
                </el-col>
                <el-col :span="8">
                        <span > 关联游戏：</span>
                        <el-select v-model="queryData.gameId" clearable>
                            <el-option v-for="game in games" :key="game.id" :value="game.id" :label="game.name" ></el-option>
                        </el-select>
                </el-col>
            </el-row>
            <el-row  type="flex"  align="middle" >
                <el-col :span="3">
                        <span> 话题： </span>
                        <el-input v-model="queryData.text" style="width: 110px" clearable></el-input>
                </el-col>
                <el-col :span="5">
                    <el-button  type="primary" @click="queryTopicsList">查询</el-button>
                    <el-button  type="primary" @click="showDetails('创建话题')">创建</el-button>              
                </el-col>
            </el-row>
        </el-card>
        <el-dialog :title="dialogTitle" center :visible.sync="dialogVisible" width="600px" >
            <el-form :model="topicEditForm" label-width="150px" ref="addTopicFormRef">
                <el-form-item label="话题名称:" >
                    <el-input  style="width: 300px" type="text" v-model="topicEditForm.text" :disabled="dialogTitle==='编辑话题'"></el-input>
                </el-form-item>
                <el-form-item label="选择游戏:" >
                    <el-select v-model="topicEditForm.gameId" filterable :disabled="dialogTitle==='编辑话题'">
                        <el-option v-for="game in games" :key="game.id" :value="game.id" :label="game.name"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="引用发帖基数:" >
                    <el-input-number  v-model="topicEditForm.base" ></el-input-number>
                </el-form-item>
                <div style="text-align: center;">
                    <el-button type="primary" @click="confirm">确 定</el-button>
                    <el-button type="info" @click="cancel">取 消</el-button>
                </div>
            </el-form>
        </el-dialog>
        <h1>
            <el-table border :data="topicList" @sort-change='sortChange' >
                <el-table-column  label="日期"  prop="dt" :formatter="formatDate"></el-table-column>
                <el-table-column  label="话题"  >
                    <template slot-scope="scope">{{" # "+scope.row.text}}</template>
                </el-table-column>
                <el-table-column  label="关联游戏" >
                    <template slot-scope="scope">{{scope.row.gameName===null?"暂无":scope.row.gameName}}</template>
                </el-table-column>
                <el-table-column  label="引用帖子数" prop="post" sortable="custom"></el-table-column>
                <el-table-column  label="引用用户数" prop="user" sortable="custom"></el-table-column>
                <el-table-column  label="热度值" prop="hot" sortable="custom"></el-table-column>
                <el-table-column  label="操作" align="center">
                    <template slot-scope="scope">
                    <el-button  plain size="mini" type="primary" @click="showDetails('编辑话题',scope.row)">编辑</el-button>
                    </template>
                </el-table-column>
                <el-table-column  label="开关" >
                    <template slot-scope="scope">
                        <el-switch v-model="scope.row.isOpen"
                                   :active-value="1"
                                   :inactive-value="0"
                                   active-text="开启"
                                   inactive-text="关闭"
                                   @change="updateOpen(scope.row)">
                        </el-switch>
                    </template>
                </el-table-column>
            </el-table>
            <el-dialog
                    title="提示"
                    :visible.sync="warningDialogVisible"
                    width="20%">
                <span>此操作将带来不可知风险，是否继续？</span>
                <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="warningConfirm">是</el-button>
                <el-button @click="warningCancel">否</el-button>
             </span>
            </el-dialog>
            <el-row>
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="page.page"
                        :page-sizes="[10,20,30,50]"
                        :page-size="page.size"
                        layout="total, sizes, prev, pager, next"
                        :total="page.totalElements">
                </el-pagination>
            </el-row>
        </h1>
    </div>
</template>

<script>
    import {
       gameListForAdmin,
       editTopic,
       searchTopic
    } from "@/http/api";
    import utils from '@/utils'
    export default {
        name: "OfficialTopic",
        data(){
           return{
               games:[],
               page: {
                   size: 10,
                   page: 1,
                   totalElements: null
               },
               warningDialogVisible: false,
               dialogVisible: false,
               dialogTitle :'',
               order: 'desc',
               orders:'isOpen desc,dt desc',
               queryData: {
                   text: '',
                   gameId: null,
                   timeDate: ['', ''],
               },
               queryTrueData: {
                   text: '',
                   gameId: null,
                   startDt: null,
                   endDt: null
               },
               topicEditForm: {},
               topicList:[]
           }
        },
        methods :{
            formatDate: function(row, column) {
                return utils.DateUtil.formatDate(row[column.property], "YYYY-MM-DD")
            },
            handleSizeChange(size) {
                this.page.size = size;
                this.queryTopicsList();
            },
            handleCurrentChange(page) {
                this.page.page = page;
                this.queryTopicsList() ;
            },
            showDetails(title, row) {
                this.topicEditForm = {
                    "id" : 0,
                    "text" :'',
                    "gameId" : 0,
                    "base" : '',
                    "post":0,
                    "user":0,
                    "isOpen":1
                };

                this.dialogTitle = title;
                this.dialogVisible = true;

                if(row){
                    this.topicEditForm = {
                        "id" : row.id,
                        "text" :row.text,
                        "gameId" : row.gameId,
                        "base" :row.base,
                        "post":row.post,
                        "user":row.user,
                        "isOpen" : row.isOpen
                    };
                }
            },
            confirm(){
                this.$refs.addTopicFormRef.validate(valid =>{
                    if(!valid){
                        return this.$message.error('请填写有效参数')
                    }
                });
                let _message = '';
                if(this.topicEditForm.text===''){
                    _message = '缺少话题内容'
                }
                if(_message){
                    this.$message({
                        message: _message,
                        type: 'error'
                    });
                    return;
                }
                editTopic(this.topicEditForm).then(resp=> {
                    if (resp.data.status===0){
                        this.dialogVisible = false;
                        this.queryTopicsList();
                    }
                })
            },
            updateOpen(row){
                this.warningDialogVisible = true;
                this.topicEditForm = {
                    "id" : row.id,
                    "text" :row.text,
                    "gameId" : row.gameId,
                    "base" :row.base,
                    "post":row.post,
                    "user":row.user,
                    "isOpen" : row.isOpen
                };
            },
            warningCancel(){
                this.queryTopicsList();
                this.warningDialogVisible = false
            },
            warningConfirm(){
                editTopic(this.topicEditForm).then(resp=> {
                    if (resp.data.status===0){
                        this.queryTopicsList();
                        this.warningDialogVisible = false
                    }
                })
            },
            cancel(){
                this.dialogVisible=false;
            },
            sortChange(order) {
                this.queryTrueData.order = order.order;
                this.queryTrueData.prop = order.prop;
                this.queryTopicsList();
            },
            queryTopicsList(){
                this.queryTrueData.text = this.queryData.text;
                this.queryTrueData.gameId= this.queryData.gameId;
                this.queryTrueData.startDt = this.queryData.timeDate[0]==='' ? null:this.queryData.timeDate[0];
                this.queryTrueData.endDt = this.queryData.timeDate[1]==='' ? null:this.queryData.timeDate[1];
                this.queryTrueData.size=this.page.size;
                this.queryTrueData.page=this.page.page;
                this.queryTrueData.orders = this.orders;
                searchTopic(this.queryTrueData).then(resp=> {
                    if (resp.data.status===0){
                       this.topicList=resp.data.info.content;
                       this.page.totalElements = resp.data.info.totalElements;
                    }
                })

            },

        },
        created() {
            gameListForAdmin().then(resp => {
                this.games = resp.data.info;
                this.games.unshift({id:0,name:'不选择'});
            });
            this.queryTopicsList();
        },
    }
</script>

<style scoped>

</style>
